import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { SmallshiService } from '../../../services/smallshi.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnChanges {

  loading = false;
  nuevasTiendas: any[] = [];
  @Input() item: string;
  @Output() ecomerce: EventEmitter<any[]>;
  constructor(private small: SmallshiService) {
    this.ecomerce = new EventEmitter;
  }

  ngOnChanges() {
    this.loading = true;
    if (this.item) this.small.datosTienda(this.item, '');
    if (this.item) this.small.getTienda(this.item).subscribe((data: any) => {
      this.small.nextDatosTienda(data);
      this.nuevasTiendas = data.data;
      this.small.datosTienda(this.nuevasTiendas['id'], this.nuevasTiendas['tlf']);
      this.small.nombreTienda = this.nuevasTiendas['nombre'];
      this.small.codigoPais = this.nuevasTiendas['codigo_pais'];
      this.small.delivery = this.nuevasTiendas['configuracion'].delivery
      this.small.tienda_lat = this.nuevasTiendas['latitude'];
      this.small.tienda_lng = this.nuevasTiendas['longitude'];
      if (data.data['configuracion']) this.small.radioDelivery = this.nuevasTiendas['configuracion'].radio_km;
      this.ecomerce.emit(this.nuevasTiendas);
      this.small.shiwallet = this.nuevasTiendas['shiwallet'];
      this.loading = false;
    });
  }
  cortar(cadena: string, cantidad: number) {
    if (cadena) return (cadena.length > cantidad ? cadena.substring(0, cantidad) + "..." : cadena);
    return '';
  }

}
